import baseApi from "@/api/baseApi";
import { transformDownload } from "@/helpers/saveFile";

const api = {
  async getProjects(hideLoader = true) {
    const response = await baseApi({
      method: "get",
      url: `/project/all`,
      data: { hideLoader },
    });

    return response.data;
  },
  async updateFavourite(data) {
    const response = await baseApi({
      method: "post",
      url: `/project/updateFavourite`,
      data: data,
    });

    return response.data;
  },

  async getProjectsKiosk() {
    const response = await baseApi({
      method: "get",
      url: `/project/kiosk/all`,
      data: { hideLoader: true },
    });

    return response.data;
  },
  async getFavoritesProjects() {
    const response = await baseApi({
      method: "get",
      url: `/project/favorites`,
      data: { hideLoader: true },
    });
    return response.data;
  },
  async getRecentProjects(top?: number) {
    const response = await baseApi({
      method: "get",
      url: `/project/recent` + (top != null ? `?top=${top}` : ``),
      data: { hideLoader: true },
    });
    return response.data;
  },
  async deleteRecentProject(projectId: number) {
    const response = await baseApi({
      method: "delete",
      url: `/project/recent/${projectId}`,
    });
    return response.data;
  },

  async getProjectsFilterOptions() {
    const response = await baseApi({
      method: "get",
      url: `/project/filteroptions`,
    });
    return response.data;
  },

  async getProjectImage(projectId) {
    const response = await baseApi({
      method: "get",
      url: `/project/${projectId}/image`,
      headers: {
        "Content-Type": "text/plain",
      },
      cache: {
        maxAge: 60 * 60 * 1000, // 60min
        exclude: { query: false },
      },
      data: { hideLoader: true },
    });
    return response.data;
  },
  async getProject(projectId) {
    const response = await baseApi.get(`/project/${projectId}`);
    return response.data;
  },
  async getProjectHouses(projectId, hideLoader = true) {
    const response = await baseApi({
      method: "get",
      url: `/project/${projectId}/houses`,
      headers: {
        "Content-Type": "text/plain",
      },
      data: { hideLoader },
    });
    return response.data;
  },
  async getProjectSections(projectId, hideLoader = true) {
    const response = await baseApi({
      method: "get",
      url: `/project/${projectId}/sections/list`,
      data: { hideLoader },
    });
    return response.data;
  },
  async getProjectContacts(projectId) {
    const response = await baseApi({
      method: "get",
      url: `/project/${projectId}/contacts`,
      data: { hideLoader: true },
    });
    return response.data;
  },
  async ueProjectAccess(projectId) {
    const response = await baseApi({
      method: "get",
      url: `/project/${projectId}/access`,
    });
    return response.data;
  },

  async getProjectMinutes(projectId) {
    const response = await baseApi({
      method: "get",
      url: `/project/${projectId}/minutes`,
      data: { hideLoader: true },
    });
    return response.data;
  },
  async previewMinute(data) {
    const response = await baseApi({
      method: "post",
      url: `/project/minute/preview`,
      data: data,
      responseType: "blob",
      transformResponse: transformDownload,
    });

    return response.data;
  },
  async getPsi(projectId) {
    const response = await baseApi({
      method: "get",
      url: `/project/${projectId}/psi`,
      responseType: "blob",
    });

    return response;
  },

  async getPhaseoptionsandchanges(houseId, pdf = false) {
    const query = pdf ? "?pdf=true" : "";
    const response = await baseApi({
      method: "get",
      url: `/project/house/${houseId}/reports/phaseoptionsandchanges${query}`,
      responseType: "blob",
    });
    return response.data;
  },

  async getColorOptions(houseId) {
    const response = await baseApi({
      method: "get",
      url: `/project/house/${houseId}/reports/coloroptions`,
      responseType: "blob",
    });
    return response.data;
  },
  async getOrdersFilterData() {
    const response = await baseApi({
      method: "get",
      url: `/project/house/orders/filters`,
      data: { hideloader: true },
    });
    return response.data;
  },
  async getProjectHouseOrders(houseId, data) {
    const response = await baseApi({
      method: "post",
      url: `/project/house/${houseId}/orders`,
      data: data,
    });
    return response.data;
  },
  async getOrder(orderId) {
    const response = await baseApi({
      method: "get",
      url: `/project/house/order/${orderId}`,
      data: { hideLoader: true },
    });
    return response.data;
  },
  async downloadOrder(orderId) {
    const response = await baseApi({
      method: "get",
      url: `/project/house/order/download/${orderId}`,
      responseType: "blob",
    });
    return response.data;
  },
  async receiveOrderGoods(orderId, orderLines) {
    const response = await baseApi({
      method: "post",
      url: `/project/house/order/${orderId}/receivedgoods`,
      data: orderLines,
    });

    return response;
  },
};

export default api;
